import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/rem'
import './common/common.css'

import bottomTab from './components/bottomTab.vue'

Vue.config.productionTip = false
Vue.component('bottom-tab', bottomTab) // 全局注册导航按钮组件

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
